import "./App.css";
import { Navigate, useRoutes } from "react-router-dom";
import InterviewScreen from "./components/interview/interview";
import InterviewMaker from "./components/dashboard/interviewMaker";
import SignupWithGoogle from "./components/signup/signupWithGoogle";
import InterviewFeedback from "./components/reusble_components/interviewFeedback";
import ReportScreen from "./components/reusble_components/reportScreen";
import VoiceDetection from "./components/reusble_components/voiceDetection";
import Profile from "./components/dashboard/profile";
import SignupPage1 from "./components/signup/SignupPage1";
import Test from "./components/mockTest/Test";
import TermsOfUse from "./components/dashboard/TermsOfUse";
import MockExamReport from "./components/dashboard/mockexamreport";
import Payment from "./components/payment/payment";
import RadixExample from "./components/UI/RadixExample";
import ConfirmationExample from "./components/UI/ConfirmationExample";

function App() {
  return useRoutes([
    {
      path: "/dashboard",
      element: <Profile />,
      // children: {
      //   path: "*",
      //   element: <Profile />,
      // },
    },
    // {
    //   path: "/certificate",
    //   element: <Dashboard />
    // },
    {
      path: "/interview-maker",
      element: <InterviewMaker />,
    },
    {
      path: "/",
      element: <SignupPage1></SignupPage1>,
      // element: <SignupPage />,
    },
    {
      path: "/radix-example",
      element: <RadixExample />,
    },
    {
      path: "/confirmation-example",
      element: <ConfirmationExample />,
    },
    {
      path: "/interview-feedback",
      element: <InterviewFeedback />,
    },
    {
      path: "/404",
      element: <h1>Not Found</h1>,
    },
    {
      path: "/interview",
      element: (
        <InterviewScreen
          technology={"react js"}
          name={"sekhar"}
          levelOfInterview={"low"}
        />
      ),
    },

    {
      path: "/report/:id",
      element: <ReportScreen />,
    },
    {
      path: "/mockexamreport",
      element: <MockExamReport />,
    },
    {
      path: "/report",
      element: <ReportScreen />,
    },
    {
      path: "/voicedetection",
      element: <VoiceDetection />,
    },
    {
      path: "/TermsOfUse",
      element: <TermsOfUse />,
      // element: <SignupPage />,
    },
    {
      path: "/payment/:id",
      element: <Payment />,
    },

    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

export default App;
